import { Box, Button } from '@mui/material'
import React from 'react'
import cash from '../../assets/images/cash-payment.png'

const HotelFare = (props) => {
  // priceDetails
  return (
    <Box className='hotelrow package-wrapper sticky-child'>
    <Box className="backtosearch">
        <Box className="fare-tlt">Fare Summary</Box>
    </Box>

    <div className="farecontentBox">
        <Box className='calcBox'>
            <Box className="faredetailsBox">
                <Box className="fareBox">
                    <Box className="tlt">Price</Box>
                </Box>
                <Box className="faredetailprice"><span>	&#x20B9; </span> <span>1650</span>
                </Box>
            </Box>

            <Box className="faredetailsBox">
                <Box className="fareBox">
                    <Box className="tlt">Taxes</Box>
                </Box>
                <Box className="faredetailprice"><span>	&#x20B9; </span> <span>300</span>
                </Box>
            </Box>

            <Box className="faredetailsBox">
                <Box className="fareBox">
                    <Box className="tlt">GST</Box>
                </Box>
                <Box className="faredetailprice"><span>	&#x20B9; </span> <span>30</span>
                </Box>
            </Box>
            <hr className='mt-2 '></hr>

            <Box className="faredetailsBox">
                <Box className="fareBox">
                    <Box className="tlt-total">Total</Box>
                </Box>
                <Box className="faredetailprice ">
                    <span className='tlt-total'><span>	&#x20B9; </span> 4000</span>

                </Box>
            </Box>
                
        </Box>
    </div>
</Box>
  )
}

export default HotelFare